import React, { useState, useEffect, useRef, useContext } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { useParams } from 'react-router-dom';
import { getArticleBySlug, updateArticle, uploadImage } from '../api/articleApi';
import { AuthContext } from '../context/authContext';

function EditArticle() {
  const { user } = useContext(AuthContext);
  const { slug } = useParams();
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');
  const [titleBel, setTitleBel] = useState('');
  const [contentBel, setContentBel] = useState('');
  const quillRef = useRef(null);
  const quillRefBe = useRef(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const articleData = await getArticleBySlug(slug);
        setTitle(articleData.title);
        setContent(articleData.content);
        setTitleBel(articleData.titleBel);
        setContentBel(articleData.contentBel);

        if (quillRef.current) {
          quillRef.current.root.innerHTML = articleData.content || '';
        }

        if (quillRefBe.current) {
          quillRefBe.current.root.innerHTML = articleData.contentBel || '';
        }
      } catch (error) {
        alert('Ошибка загрузки статьи. Попробуйте еще раз.');
      }
    };

    fetchArticle();
  }, [slug]);

  useEffect(() => {
    if (!quillRef.current) {
      const quill = new Quill('#editor-ru', {
        theme: 'snow',
      });

      quillRef.current = quill;

      quill.on('text-change', () => {
        const newContent = quill.root.innerHTML;
        setContent(newContent);
      });
    }

    if (!quillRefBe.current) {
      const quill = new Quill('#editor-be', { theme: 'snow' });
      quillRefBe.current = quill;

      quill.on('text-change', () => {
        const html = quill.root.innerHTML;
        setContentBel(html);
      });
    }
  }, []);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const data = await uploadImage(file, user.token);
      const imagePath = data.filePath;

      const quills = [quillRef.current, quillRefBe.current];
      quills.forEach((quill) => {
        if (!quill) return;
        quill.focus();
        const index = quill.getLength();
        quill.insertEmbed(index, 'image', imagePath);
        quill.setSelection(index + 1);
      });
    } catch (error) {
      alert('Ошибка загрузки изображения: ' + error.message);
    }
  };

  const handleSubmit = async () => {
    if (!title.trim() || !title.trim()) {
      alert('Введите заголовок статьи');
      return;
    }

    try {
      if (user) {
        await updateArticle(slug, title, content, titleBel, contentBel, user.token);
        window.location.href = `/articles/${slug}`;
      }
    } catch (error) {
      alert('Ошибка при обновлении статьи. Попробуйте еще раз.');
    }
  };

  return (
    <div className="editor-page-container">
      <h1>Редактировать статью</h1>

      <h2>Русская версия</h2>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Введите заголовок статьи"
        className="article-title-input"
        autoFocus
        style={{ marginBottom: '20px', padding: '10px', width: '100%' }}
      />
      <div className="uploads" style={{ margin: '20px 0' }}>
        <input type="file" accept="image/png, image/jpeg, image/jpg" onChange={handleImageUpload} />
        <p>Вы можете загрузить фотографии, разрешены .png, .jpg, .jpeg</p>
      </div>

      <div id="editor-ru"></div>
      <div dangerouslySetInnerHTML={{ __html: `<hr class="editor-divider" />` }}></div>

      <h2>Беларуская версія</h2>
      <input
        type="text"
        value={titleBel}
        className="article-title-input"
        onChange={(e) => {
          setTitleBel(e.target.value);
        }}
        placeholder="Увядзіце загаловак па-беларуску"
        style={{ marginBottom: '10px', padding: '10px', width: '100%' }}
      />
      <div id="editor-be"></div>

      <button onClick={handleSubmit} style={{ marginTop: '20px' }}>
        Сохранить изменения
      </button>
    </div>
  );
}

export default EditArticle;
